import { ResolveTypes, Transition } from '@uirouter/angular';
import { BPWizardComponent } from './bp-wizard.component';
import {
  STATE_BPPROFILES_BANK, STATE_BPPROFILES_CONTRACT,
  STATE_BPPROFILES_OEM_OVERVIEW,
  STATE_BPPROFILES_TC,
  STATE_BPWIZARD,
  STATE_BPWIZARD_AGREEMENT,
  STATE_BPWIZARD_BANK,
  STATE_BPWIZARD_BILLINGMETHODS,
  STATE_BPWIZARD_COMPANYMARGIN,
  STATE_BPWIZARD_FEES,
  STATE_BPWIZARD_GENERAL,
  STATE_BPWIZARD_OEM,
  STATE_BPWIZARD_PAYMENTSOURCE,
  STATE_BPWIZARD_PAYMENTTERMS, STATE_BPWIZARD_THANKYOU, STATE_BPWIZARD_WELCOME
} from '@app/shared/app-states';
import { BPWizardAgreementComponent } from './agreement/bp-wizard-agreement.component';
import { BPWizardBankComponent } from './bank/bp-wizard-bank.component';
import { BPWizardBillingMethodsComponent } from './billing-methods/bp-wizard-billing-methods.component';
import { BPWizardCompanyMarginComponent } from './company-margin/bp-wizard-company-margin.component';
import { BPWizardFeesComponent } from './fees/bp-wizard-fees.component';
import { BPWizardGeneralComponent } from './general/bp-wizard-general.component';
import { BPWizardOEMComponent } from './oem/bp-wizard-oem.component';
import { BPWizardPaymentSourceComponent } from './payment-source/bp-wizard-payment-source.component';
import { BPWizardPaymentTermsComponent } from './payment-terms/bp-wizard-payment-terms.component';
import { BPWizardThankYouComponent } from './thank-you/bp-wizard-thank-you.component';
import { BPWizardWelcomeComponent } from './welcome/bp-wizard-welcome.component';
import { GaStateDeclaration } from '@type_definitions/datatypes';
import { TRANSLATION_READY_RESOLVER } from '@app/app-routes.config';

const BPWIZARD_TITLE:string = 'BPWIZARD.TITLE';

const PROFILE_ID_RESOLVER:ResolveTypes = { token: 'profileId', deps: [Transition], resolveFn: (transition:Transition) => transition.params()?.profileId };

export const BP_WIZARD_STATES:GaStateDeclaration[] = [
  {
    name: STATE_BPWIZARD_WELCOME,
    url: '/bpwizard/welcome?profileId',
    component: BPWizardWelcomeComponent,
    data: {
      viewTitle: [
        BPWIZARD_TITLE,
        'BPWIZARD.WELCOME.HEADING.TITLE'
      ]
    },
    resolve: [TRANSLATION_READY_RESOLVER, PROFILE_ID_RESOLVER]
  },
  {
    name: STATE_BPWIZARD,
    url: '/bpwizard?profileId',
    abstract: true,
    component: BPWizardComponent,
    resolve: [TRANSLATION_READY_RESOLVER, PROFILE_ID_RESOLVER]
  },
  {
    name: STATE_BPWIZARD_GENERAL,
    url: '/general',
    component: BPWizardGeneralComponent,
    data: {
      viewTitle: [
        BPWIZARD_TITLE,
        'BPWIZARD.GENERAL.HEADING.TITLE'
      ]
    }
  },
  {
    name: STATE_BPWIZARD_OEM,
    url: '/oem',
    component: BPWizardOEMComponent,
    data: {
      viewTitle: [
        BPWIZARD_TITLE,
        'BPWIZARD.OEM.HEADING.TITLE'
      ],
      advancedState: STATE_BPPROFILES_OEM_OVERVIEW
    }
  },
  {
    name: STATE_BPWIZARD_COMPANYMARGIN,
    url: '/company-margin',
    component: BPWizardCompanyMarginComponent,
    data: {
      viewTitle: [
        BPWIZARD_TITLE,
        'BPWIZARD.COMPANY_MARGIN.HEADING.TITLE'
      ],
      advancedState: STATE_BPPROFILES_TC
    }
  },
  {
    name: STATE_BPWIZARD_PAYMENTTERMS,
    url: '/payment-terms',
    component: BPWizardPaymentTermsComponent,
    data: {
      viewTitle: [
        BPWIZARD_TITLE,
        'BPWIZARD.PAYMENT_TERMS.HEADING.TITLE'
      ],
      advancedState: STATE_BPPROFILES_TC
    }
  },
  {
    name: STATE_BPWIZARD_BILLINGMETHODS,
    url: '/billing-methods',
    component: BPWizardBillingMethodsComponent,
    data: {
      viewTitle: [
        BPWIZARD_TITLE,
        'BPWIZARD.BILLING_METHODS.HEADING.TITLE'
      ],
      advancedState: STATE_BPPROFILES_TC
    }
  },
  {
    name: STATE_BPWIZARD_BANK,
    url: '/bank-details',
    component: BPWizardBankComponent,
    data: {
      viewTitle: [
        BPWIZARD_TITLE,
        'BPWIZARD.BANK_DETAILS.HEADING.TITLE'
      ],
      advancedState: STATE_BPPROFILES_BANK
    }
  },
  {
    name: STATE_BPWIZARD_PAYMENTSOURCE,
    url: '/payment-source',
    component: BPWizardPaymentSourceComponent,
    data: {
      viewTitle: [
        BPWIZARD_TITLE,
        'BPWIZARD.PAYMENT_SOURCE.HEADING.TITLE'
      ],
      advancedState: STATE_BPPROFILES_TC
    }
  },
  {
    name: STATE_BPWIZARD_FEES,
    url: '/fees',
    component: BPWizardFeesComponent,
    data: {
      viewTitle: [
        BPWIZARD_TITLE,
        'BPWIZARD.FEES.HEADING.TITLE'
      ],
      advancedState: STATE_BPPROFILES_TC
    }
  },
  {
    name: STATE_BPWIZARD_AGREEMENT,
    url: '/agreement',
    component: BPWizardAgreementComponent,
    data: {
      viewTitle: [
        BPWIZARD_TITLE,
        'BPWIZARD.AGREEMENT.HEADING.TITLE'
      ],
      advancedState: STATE_BPPROFILES_CONTRACT
    }
  },
  {
    name: STATE_BPWIZARD_THANKYOU,
    url: '/bpwizard/thank-you?profileId',
    component: BPWizardThankYouComponent,
    data: {
      viewTitle: [
        BPWIZARD_TITLE,
        'BPWIZARD.THANK_YOU.HEADING.TITLE'
      ]
    },
    resolve: [TRANSLATION_READY_RESOLVER, PROFILE_ID_RESOLVER]
  }
];